import { connect } from 'react-redux'
// import { bindActionCreators } from 'redux'
// import { NavigationActions } from 'react-navigation'
import { getState, getDispatch } from 'x/modules/print/BasePrintShippingLabelViewConnect'
import { getStoreSelected, getSubscription, getOrder } from 'x/redux/selectors'
import PrintShippingLabelView from './PrintShippingLabelView'

export default connect(
  (state) => ({
    selectedStore: getStoreSelected(state),
    subscription: getSubscription(state),
    order: getOrder(state),
    state: getState(state),
  }),
  (dispatch) => {
    return {
      ...getDispatch(dispatch),
      // navigate: bindActionCreators(NavigationActions.navigate, dispatch),
    }
  }
)(PrintShippingLabelView)
